import { render, staticRenderFns } from "./settingTaxes.vue?vue&type=template&id=bbeb78de&scoped=true&"
import script from "./settingTaxes.vue?vue&type=script&lang=js&"
export * from "./settingTaxes.vue?vue&type=script&lang=js&"
import style0 from "./settingTaxes.vue?vue&type=style&index=0&id=bbeb78de&prod&lang=scss&scoped=true&"
import style1 from "./settingTaxes.vue?vue&type=style&index=1&id=bbeb78de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbeb78de",
  null
  
)

export default component.exports